import { createContext } from "react";

interface IssueLogContextActions {
  toggleExportPanel: () => void;
  isInIssuesLog: boolean;
}

// some functions in the log (e.g. changing panels) need to be accessible from deeply
// nested parts of the issue log, so we have a context for that.
export const issueLogContext = createContext<IssueLogContextActions>({
  toggleExportPanel: () => {
    console.warn("toggleExportPanel called without a provider context");
  },
  isInIssuesLog: false,
});
